import Editor, { EditorRefHandle } from './Editor'
import './Editor.scss'

export type { EditorRefHandle }
export default Editor